// @mui material components
import Icon from '@mui/material/Icon';

// @mui icons
import AboutUs from 'layouts/pages/landing-pages/about-us';
import Support from 'layouts/pages/support';
import ContactUs from 'layouts/pages/contact-us';
import Presentation from 'layouts/pages/presentation';
import DataAnalyticsMorePage from 'layouts/pages/dataAnalyticsMorePage';
import DataProtectionMorePage from 'layouts/pages/dataProtectionMorePage';
import EnterpriseDataManagementMorePage from 'layouts/pages/enterpriseDataManagementMorePage';
import ManagedServicesAndStaffAugmentationMorePage from 'layouts/pages/managedServicesAndStaffAugmentationMorePage';
import TrainingMorePage from 'layouts/pages/trainingMorePage';
import SoftwareDevelopmentMorePage from 'layouts/pages/softwareDevelopmentMorePage';
import TermsOfService from './layouts/pages/termsOfService';
import websiteNameByBrand from './utils/websiteNameByBrand';

const brand = websiteNameByBrand();
const routes = [
    {
        type: 'nav',
        name: 'home',
        icon: <Icon>home</Icon>,
        route: '/',
        component: <Presentation/>,
    },
    {
        type: 'nav',
        name: 'services',
        icon: <Icon>build</Icon>,
        collapse: [
            {
                type: 'nav',
                name: 'Data Analytics',
                description: 'See all data services',
                dropdown: true,
                collapse: [
                    {
                        type: 'nav',
                        name: 'data analytics (more)',
                        route: '/service/data-analytics-more',
                        component: <DataAnalyticsMorePage/>,
                    },
                ],
            },
            ...(brand.title === 'SHPRIVACY' ?
                [{
                    type: 'nav',
                    name: 'Data Protection',
                    description: 'See all data protection services',
                    dropdown: true,
                    collapse: [
                        {
                            type: 'nav',
                            name: 'Data Protection (more)',
                            route: '/service/data-protection',
                            component: <DataProtectionMorePage />,
                        },
                    ]
                }]
              : []),
            {
                type: 'nav',
                name: 'Enterprise Data Management',
                description: 'See all EDM services',
                dropdown: true,
                collapse: [
                    {
                        type: 'nav',
                        name: 'Enterprise Data Management (more)',
                        route: '/pages/service/enterprise-data-management-more',
                        component: <EnterpriseDataManagementMorePage/>,
                    },
                ],
            },
            {
                type: 'nav',
                name: 'Managed Services and Staff Augmentation',
                description: 'See all MSSA services',
                dropdown: true,
                collapse: [
                    {
                        type: 'nav',
                        name: 'Managed Services and Staff Augmentation (more)',
                        route: '/pages/service/managed-services-and-staff-augmentation',
                        component: <ManagedServicesAndStaffAugmentationMorePage/>,
                    },
                ],
            },
            {
                type: 'nav',
                name: 'Software Development',
                description: 'See all software development services',
                dropdown: true,
                collapse: [
                    {
                        type: 'nav',
                        name: 'Software Development',
                        route: '/pages/service/software-development-more',
                        component: <SoftwareDevelopmentMorePage/>,
                    },
                ],
            },
            {
                type: 'nav',
                name: 'Training',
                description: 'See all training services',
                dropdown: true,
                collapse: [
                    {
                        type: 'nav',
                        name: 'Training',
                        route: '/pages/service/training',
                        component: <TrainingMorePage/>,
                    },
                ],
            },
        ],
    },
    {
        type: 'nav',
        name: 'Support',
        icon: <Icon>support</Icon>,
        route: '/pages/support',
        component: <Support/>,
    },
    {
        type: 'nav',
        name: 'Contact Us',
        icon: <Icon>contacts</Icon>,
        route: '/pages/contact-us',
        component: <ContactUs/>,
    },
    {
        type: 'nav',
        name: 'About Us',
        icon: <Icon>info</Icon>,
        route: '/pages/landing-pages/about-us',
        component: <AboutUs/>,
    },
];

export const buttonRoutes = [
    {
        type: 'but',
        name: 'termsOfService',
        route: '/pages/terms_of_service',
        component: <TermsOfService/>,
    },
];

export default routes;
